import type * as THREE from 'three';

/** Bounds computed by a geometry producer during its existing position pass. */
export const geometryBoundsVersions = new WeakMap<
  THREE.BufferGeometry,
  { position: THREE.BufferAttribute; version: number }
>();

export function markGeometryBounds(
  geometry: THREE.BufferGeometry,
  position: THREE.BufferAttribute,
): void {
  const bounds = geometryBoundsVersions.get(geometry);
  if (bounds === undefined)
    geometryBoundsVersions.set(geometry, { position, version: position.version });
  else {
    bounds.position = position;
    bounds.version = position.version;
  }
}
